import React, { useState, useEffect, useRef } from "react";
import Table from "../../../../components/Table";
import Pagination from "../../../../components/Pagination";
import GetData from "../../../../api/GetData";
import document from "../../../../assets/images/doc.png";

export default function PayoutUpload() {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [file, setFile] = useState(null); // Store selected file
  const [files, setFiles] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const postPerPage = 50;
  const lastPageNum = Math.ceil(totalCount / postPerPage);
  const pageStart = (pageNumber - 1) * postPerPage + 1;

  const inputRef = useRef();

  // Mock function to handle file upload (You would replace it with actual API call)
  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const uploadedFile = e.dataTransfer.files[0]; // Get the first dropped file
    setFile(uploadedFile); // Set the file
    setFiles(e.dataTransfer.files);
  };

  const handleUploadSubmit = async () => {
    if (!file) return;

    // Add logic to handle file upload, e.g., POST to an API endpoint.
    console.log("File uploaded:", file);

    // Mock API Call to save file details or refresh uploaded files
    // fetchUploadedFiles();
  };

  const handleFileSelect = (e) => {
    const selectedFile = e.target.files[0]; // Get the first selected file
    setFile(selectedFile); // Set the file
    setFiles(e.target.files);
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Batch Name",
        accessor: "batch_name",
      },
      {
        Header: "Uploaded On",
        accessor: (date) => {
          let uploadDate = date.uploaded_on;
          const formattedDate = new Date(uploadDate).toLocaleString();
          return <div>{formattedDate}</div>;
        },
      },
      {
        Header: "No. of Payouts",
        accessor: "payouts_count",
      },
      {
        Header: "Status",
        accessor: (status) => (
          <div style={{ color: status === "success" ? "#106745" : "#DE0000" }}>
            {status}
          </div>
        ),
      },
      {
        Header: "Reason",
        accessor: "reason",
      },
    ],
    [pageNumber]
  );

  return (
    <div className="gateway-settings-tab">
      <div className="payout-upload">
        <h4>Payout Upload</h4>
        <div className="file-upload justify-content-start">
          <div className="file-upload-card">
            <div
              className="file-upload-area"
              onDragOver={handleDragOver}
              onDrop={handleDrop}
              onClick={() => inputRef.current.click()}
            >
              <input
                type="file"
                accept=".xlsx, .csv"
                onChange={handleFileSelect}
                hidden
                ref={inputRef}
              />
              <div className="d-flex justify-content-center">
                <img src={document} alt="document" />
              </div>
              <p className="text-center mt-2">
                Select An Excel File To Upload <br /> Or Drag File Here
              </p>
            </div>
          </div>
        </div>

        {/* Display the selected file name */}
        {file && (
          <div className="uploaded-file-info mt-2">
            <p>Selected File: {file.name}</p>
          </div>
        )}

        <h6 className="mt-3">Previously Uploaded Batches</h6>
        <div className="history-table table-responsive">
          {uploadedFiles && uploadedFiles.length > 0 ? (
            <Table
              columns={columns}
              data={uploadedFiles}
              enableRowSelection={false}
              tableClass={"table table-borderless table-striped mb-0"}
            />
          ) : (
            <p>No record found</p>
          )}
          {lastPageNum > 1 && (
            <Pagination
              prevPage={pageNumber - 1}
              nextPage={pageNumber + 1}
              totalPages={lastPageNum}
              hasNextPage={pageNumber < lastPageNum}
              hasPrevPage={pageNumber > 1}
              setPageNum={setPageNumber}
            />
          )}
        </div>
      </div>
    </div>
  );
}
